module.exports = __webpack_public_path__ + "img/metal-big.99d80e70.jpg";